export default () => {
  const toggleButton = $('.rtl-nav-toggle');
  const sideNav = $('.mdl-layout__drawer--rtl');
  const obfuscator = $('<div class="mdl-layout__obfuscator mdl-layout__obfuscator--rtl"></div>').appendTo('.mdl-layout');
  const closeButtons = $('.mdl-layout__title .material-icons');

  let state = false;

  const toggleNav = () => {
    state = !state;
    obfuscator.toggleClass('is-visible', state);
    sideNav.toggleClass('is-visible', state);
  };

  toggleButton.on('click', toggleNav);
  obfuscator.on('click', toggleNav);
  closeButtons.on('click', () => {
    $('.mdl-layout__obfuscator.is-visible').click();
  });
};
